import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
const mapState = (state) => {
    return {
        loading: state.global.loading
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoReset: () => {
		    dispatch({ "type": "RECUPERAR_RESET_PASO"});
		}
    }
}

class Exito extends React.Component {

    enviarLogin = () => {
        this.props.pasoReset();
        goTo("login");
        //self.window.location = "/#!/login";
    }
    
    render() {
        return <div className='text-content no-margin'>
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <h3>Cambio exitoso</h3>
                    <br />
                </div>
            </div>
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <img src={require("../img/vector_ok.png")} />
                    <br />
                </div>
            </div>
            {/*<div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <h5>Tu contraseña fue restablecida con éxito.</h5>
                    <br />
                </div>
            </div>*/}
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <div className="col text-center">
                                        <p>Tu contraseña fue restablecida con éxito.</p>
                                    </div>
                </div>
            </div>
            <div className="row">
                <div style={{"textAlign": "center"}}>
                    <a onClick={this.enviarLogin} className="btn txt-orange">Iniciar Sesión</a>
                </div>
            </div>
			
		</div>;
    }
}

export default connect(mapState, mapDispatch)(Exito);


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/exito.cmpt.js